import { api } from 'store/services/general.services';

/** Separate from video BroadCast/Jitsi `start_time` so the two timers never clash. */
const START_KEY = 'chat_room_presence_start';
const ROOM_KEY = 'chat_room_presence_id';

/**
 * Start (or keep) a wall-clock presence timer for a joined chat room.
 * Switching rooms flushes the previous room first.
 */
export function startChatRoomPresence(roomId: string | number): void {
  const id = String(roomId);
  const existingRoom = localStorage.getItem(ROOM_KEY);
  const existingStart = localStorage.getItem(START_KEY);

  if (existingRoom === id && existingStart) {
    return;
  }

  if (existingRoom && existingRoom !== id) {
    flushChatRoomPresence();
  }

  localStorage.setItem(START_KEY, String(Date.now()));
  localStorage.setItem(ROOM_KEY, id);
}

/**
 * Persist elapsed whole minutes for the active chat room via rooms/logged-time,
 * then clear the timer. Same accumulation path as video call time.
 */
export function flushChatRoomPresence(): void {
  const startRaw = localStorage.getItem(START_KEY);
  const roomId = localStorage.getItem(ROOM_KEY);

  localStorage.removeItem(START_KEY);
  localStorage.removeItem(ROOM_KEY);

  if (!startRaw || !roomId) {
    return;
  }

  const start = parseInt(startRaw, 10);
  if (Number.isNaN(start)) {
    return;
  }

  const minutes = Math.floor((Date.now() - start) / 60000);
  if (minutes < 1) {
    return;
  }

  api
    .setLoggedTimeRequest({
      total_spend_time: minutes,
      room_id: roomId,
      logged_type: 'CHAT',
      presence_start: start,
    })
    .catch((error) => {
      console.warn('Failed to log chat room presence time:', error);
    });
}
